import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { PedidoIntegracaoEcommerceImportModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoIntegracaoEcommerceImportModalComponent
    ],
    exports: [
        PedidoIntegracaoEcommerceImportModalComponent
    ]
})
export class PedidoIntegracaoEcommerceImportModule { }
